import { Pills } from '@amelio/ui-library';

import { InfoTooltip } from './InfoTooltip';

import { useAmelioTranslations } from '@/hooks';

export interface NotRepresentativePillProps {
    /** Headcount a manager needs before their average is read as representative. */
    minimumHeadcount: number;
    dataTestId: string;
}

/**
 * Badge flagging a manager whose cohort is too small for their average to mean much. The
 * threshold itself lives in the tooltip rather than in a banner above the chart: it only matters
 * on the rows that fall under it.
 */
export const NotRepresentativePill = ({
    minimumHeadcount,
    dataTestId,
}: NotRepresentativePillProps) => {
    const { t } = useAmelioTranslations();

    return (
        <InfoTooltip
            message={t('calibration.deviation.notRepresentativeTooltip', {
                count: minimumHeadcount,
            })}
            dataTestId={dataTestId}
        >
            <Pills
                size={'sm'}
                variant={'default'}
            >
                {t('calibration.deviation.notRepresentative')}
            </Pills>
        </InfoTooltip>
    );
};
